import { render } from "./SelectCourseProblem.vue?vue&type=template&id=7b2cff51&scoped=true&ts=true"
import script from "./SelectCourseProblem.vue?vue&type=script&lang=ts"
export * from "./SelectCourseProblem.vue?vue&type=script&lang=ts"

import "./SelectCourseProblem.vue?vue&type=style&index=0&id=7b2cff51&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2cff51"]])

export default __exports__